import CKEditorInspector from "@ckeditor/ckeditor5-inspector";
import { Command, Plugin, ButtonExecuteEvent, ButtonView } from "ckeditor5";

import { IconSearchLine } from "@examspark/common-ui/dist/components/icons";

export const COMMAND_INSPECT = "inspect";
export const UI_BUTTON_INSPECT = "inspect";

export class InspectEditorCommand extends Command {
  execute(openInspector?: boolean) {
    if (this.editor.inspectorName == null) return;

    const inspectorSelector = document.getElementById(
      "inspector-editor-selector",
    ) as HTMLSelectElement;
    if (inspectorSelector == null) return;

    inspectorSelector.value = this.editor.inspectorName;
    inspectorSelector.dispatchEvent(new Event("change", { bubbles: true }));

    const isCollapsed = Array.from(document.body.classList).includes(
      "ck-inspector-body-collapsed",
    );

    if (isCollapsed && openInspector) {
      const inspectorButton = document.querySelector(
        ".ck-inspector-navbox__navigation__toggle",
      );
      inspectorButton?.dispatchEvent(new Event("click", { bubbles: true }));
    }
  }
}

export default class InspectorHelper extends Plugin {
  init() {
    if (
      !this.editor.config.get("enableInspector") &&
      !process.env.ENABLE_CKEDITOR_INSPECTOR
    )
      return;

    const [inspectorName] = CKEditorInspector.attach(this.editor);

    Object.defineProperty(this.editor, "inspectorName", {
      value: inspectorName,
    });

    this.editor.commands.add(
      COMMAND_INSPECT,
      new InspectEditorCommand(this.editor),
    );

    this.editor.ui.focusTracker.on(
      "change:isFocused",
      (_evt, _data, isFocused) => {
        if (!isFocused) return;
        this.editor.execute(COMMAND_INSPECT);
      },
    );

    this.editor.ui.componentFactory.add(UI_BUTTON_INSPECT, (locale) => {
      const button = new ButtonView(locale);

      button.set({
        tooltip: `Inspect ${inspectorName}`,
        icon: IconSearchLine.Content,
      });

      button.on<ButtonExecuteEvent>("execute", () =>
        this.editor.execute(COMMAND_INSPECT, true),
      );

      return button;
    });
  }
}

declare module "ckeditor5" {
  interface EditorConfig {
    enableInspector?: boolean;
  }

  interface Editor {
    inspectorName?: string;
  }
}
